const StreamerTransport = require('./StreamerTransport')

class Streamer {

    constructor (props) {
        if (!props) {
            console.log('cannot construct streamer 1')   
        }

        this.endpoint = props.endpoint
        this.streamName = props.streamName
        this.events = []

        // Up to and including what's been pushed
        this.pushCursor = -1
    }

    async init () {
        if (this.initialised) {
            return
        }

        const streamerTransportInitialised = await StreamerTransport.init({
            endpoint: this.endpoint
        })

        if (!streamerTransportInitialised) {
            return
        }

        this.initBatching()

        this.initialised = true
    }

    getEventsToPushCount () {
        if (this.pushCursor === -1) {
            // No events pushed
            return this.events.length
        }

        if (this.pushCursor > this.events.length - 1) {
            // Pushed all events
            return 0
        }

        // Events to be pushed
        return this.events.length - (this.pushCursor + 1)
    }

    getEventsToPush () {
        if (this.pushCursor === -1) {
            return this.events
        }

        if (this.pushCursor > this.events.length - 1) {
            return []
        }

        return this.events.slice(this.pushCursor + 1)
    }

    initBatching () {
        this.schedule()
    }

    handleBatch () {

    }

    schedule () {
        setInterval(() => {
            const eventsToPush = this.getEventsToPush()

            if (!eventsToPush || eventsToPush.length === 0) {
                return
            }

            StreamerTransport.push(this.streamName, eventsToPush)
            this.pushCursor = this.pushCursor + eventsToPush.length
        }, Streamer.SCHEDULE_INTERVAL)
    }

    async addEvent (event) {
        if (!this.initialised) {
            console.error('streamer not initialised')
            return
        }

        if (!StreamerTransport.initialised) {
            console.error('streamer transport not initialised')
            return
        }

        this.events.push(event)
        this.handleBatch()
    }

    async add (event) {
        Streamer.addEvent(event)
    }

}

// ms
Streamer.SCHEDULE_INTERVAL = 1000

module.exports = Streamer
